import React from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import Yup from "yup";
import get from "lodash/get";
import has from "lodash/has";
import { withStyles } from "@mui/styles";
import { FormControl, TextField, FormHelperText } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SimpleSnackbar from "common/components/SimpleSnackbar";
import { FORM_SUBMISSION_ERROR } from "common/constants";
import ImageUploader from "core/ImageUploader";
import resourceFactory from "common/admin/resourceFactory";
import SubmitButton from "common/components/SubmitButton";
import axios from "axios";
const validationSchema = Yup.object().shape({
  name: Yup.string().required("Provider name is required"),
  url: Yup.string().url().required("Provider logo is required"),
});

const FormFoodOrderingManagement = ({
  classes,
  handleSubmit,
  initialValues,
  isEdit,
}) => {
  const generateImageUrl = (file, setFieldValue) => {
    const action = resourceFactory("gcp_services/generateSignedUrl");
    action.create({ fileName: file.name }).then((data) => {
      axios({
        url: data.url,
        method: "PUT",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: file,
      }).then(() => {
        setFieldValue("url", data.publicUrl);
      });
    });
  };
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({
        values,
        errors,
        handleChange,
        status,
        touched,
        setErrors,
        setFieldTouched,
        setFieldValue,
        isSubmitting,
      }) => (
        <Form>
          <Grid size={{ xs: 6 }}>
            <ImageUploader
              buttonId="food_image_uploader_btn"
              inputId="food_image_input"
              label="Upload Logo"
              caption="Recommended dimensions 512px x 512px"
              initialImageUrl={values.url}
              touched={touched.url}
              onError={(text) => {
                setErrors({ url: text });
              }}
              onChange={(file) => {
                setFieldTouched("url");
                generateImageUrl(file, setFieldValue);
              }}
            />
            {has(errors, "url") ? (
              <FormHelperText error>{errors.url}</FormHelperText>
            ) : null}
          </Grid>
          <Grid size={{ xs: 12 }}>
            <FormControl className={classes.formControl}>
              <TextField
                error={touched.name && has(errors, "name")}
                id="name"
                type="text"
                label="Provider Name"
                margin="normal"
                helperText={touched.name && get(errors, "name")}
                onChange={handleChange}
                value={values.name}
              />
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12 }}>
            <SubmitButton isSubmitting={isSubmitting}>
              {isEdit ? "Update Provider" : "Create Provider"}
            </SubmitButton>
            {has(errors, "http") && (
              <SimpleSnackbar message={FORM_SUBMISSION_ERROR} />
            )}
          </Grid>
          {get(status, "success") && (
            <SimpleSnackbar
              message={isEdit ? "Provider updated!" : "Provider Created!"}
            />
          )}
        </Form>
      )}
    </Formik>
  );
};

const styles = (theme) => ({
  button: {
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
});

FormFoodOrderingManagement.propTypes = {
  classes: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  isEdit: PropTypes.bool.isRequired,
};

export default withStyles(styles)(FormFoodOrderingManagement);
